"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.UtensilsSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<g stroke="none"><path d="M8.39 3.506a.536.536 0 0 1 1.07-.015l.438 5.261a.27.27 0 0 0 .539-.003l.446-6.25a.535.535 0 0 1 .906-.35.524.524 0 0 1 .165.35l.447 6.25a.269.269 0 0 0 .348.24.27.27 0 0 0 .19-.237l.439-5.26a.536.536 0 0 1 1.069.014l.386 6.95a3 3 0 0 1-1.121 2.51c-.79.631-.793.98-.793 1.995V28.5a1.5 1.5 0 1 1-3 0V14.961c0-1.015-.004-1.364-.793-1.995a3 3 0 0 1-1.121-2.51l.386-6.95z"></path><path d="M21.919 14.838c.003-.57.032-1.142.368-1.334 1.542-.881 2.438-2.651 2.261-4.42C24.241 6.015 23.632 2 20.419 2c-3.213 0-3.822 4.015-4.13 7.085-.176 1.768.72 3.538 2.262 4.419.368.21.368.878.368 1.496v13.5a1.5 1.5 0 0 0 3 0V14.838z"></path></g>';
var UtensilsSVG = function UtensilsSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.UtensilsSVG = UtensilsSVG;
UtensilsSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(UtensilsSVG);
exports.default = _default;